import { VerseDefaultView } from "./VerseDefaultView";
import { VerseAdvancedView } from "./VerseAdvancedView";
import { useSelect, select } from "@wordpress/data";
import DOMPurify from "dompurify";
import { STORE_NAME } from "../store";
import parse from "html-react-parser";
import { PrevNextNavigation } from "./PrevNextNavigation";
import { highlightSearchTerm } from './highlightSearchTerm';

export const Chapter = () => {
	const verses = select( STORE_NAME ).getVerses();
	const chapters = select( STORE_NAME ).getChapters();
	const currentChapter = chapters.find(chapter => chapter.current);
	const title = currentChapter.title;

	const getNext = () => {
		const currentChapterIndex = chapters.findIndex(chapter => chapter.current);
		if (currentChapterIndex < chapters.length - 1) {
			return chapters[currentChapterIndex + 1];

		}
		return null;
	}
	const getPrev = () => {
		const currentChapterIndex = chapters.findIndex(chapter => chapter.current);
		if (currentChapterIndex > 0) {
			return chapters[currentChapterIndex - 1];
		}
		return null;
	}

	if (verses.length === 1) {
		const urlParams = new URLSearchParams( window.location.search );
		const searchTerm = urlParams.get( 'search' );
		const text = searchTerm ? highlightSearchTerm( verses[0].commentary, searchTerm ) : verses[0].commentary;
		
		return (
			<>
				<h1 className="mb-5 text-center mt-5" >{title}</h1>
				<div className="text-justify" >
					{parse(DOMPurify.sanitize(text))}
				</div>
				<PrevNextNavigation prev={getPrev()} next={getNext()} />
			</>
		);
	}
  
	const isAdvancedView = useSelect(
		(select) => select(STORE_NAME).isAdvancedView(),
		[],
	);

	return (
		<>
			<h1 className="mb-5 mt-5 text-xl lg:text-3xl sm:text-2xl sm:mt-4 text-center">{title}</h1>
			{isAdvancedView
				? verses.map((verse, index) => (
					<VerseAdvancedView {...verse} key={index} />
				))
				: verses.map((verse, index) => (
					<VerseDefaultView {...verse} key={index} />
				))}

			<PrevNextNavigation prev={getPrev()} next={getNext()} />
		</>
	);
};
